var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequirements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_26922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89 19.8503C4.44 19.8503 0 15.4103 0 9.96031C0 4.51031 4.44 0.0703125 9.89 0.0703125C15.34 0.0703125 19.78 4.51031 19.78 9.96031C19.78 15.4103 15.34 19.8503 9.89 19.8503ZM9.89 2.04031C5.52 2.04031 1.97 5.59031 1.97 9.96031C1.97 14.3303 5.52 17.8703 9.88 17.8703C14.24 17.8703 17.79 14.3203 17.79 9.96031C17.79 5.60031 14.25 2.04031 9.89 2.04031Z",
    fill: "#B4BED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1801 13.6208C11.1801 14.3108 10.6001 14.8708 9.8901 14.8708C9.1801 14.8708 8.6001 14.3108 8.6001 13.6208V9.84082C8.6001 9.15082 9.1801 8.59082 9.8901 8.59082C10.6001 8.59082 11.1801 9.15082 11.1801 9.84082V13.6208Z",
    fill: "#B5BFD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8901 7.63078C10.6025 7.63078 11.1801 7.05323 11.1801 6.34078C11.1801 5.62833 10.6025 5.05078 9.8901 5.05078C9.17765 5.05078 8.6001 5.62833 8.6001 6.34078C8.6001 7.05323 9.17765 7.63078 9.8901 7.63078Z",
    fill: "#B5BFD4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_26922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.78,
    height: 19.78,
    fill: "white",
    transform: "translate(0 0.0703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirements);
export default __webpack_public_path__ + "static/media/requirements.2f61d7b735886f61fa541190f6335cb4.svg";
export { ForwardRef as ReactComponent };